import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import { FaPlus, FaTrash } from 'react-icons/fa';
import '../styles/pages/ModalLoan.css';

function ModalCreateLoanType({ onClose, onCreated }) {
  const [open, setOpen] = useState(true);
  const [loanType, setLoanType] = useState('');
  const [brackets, setBrackets] = useState([{ range: '', interest_rate: '' }]);
  const [error, setError] = useState(null);

  const handleBracketChange = (index, field, value) => {
    const newBrackets = [...brackets];
    newBrackets[index][field] = value;
    setBrackets(newBrackets);
  };

  const addBracket = () => {
    setBrackets([...brackets, { range: '', interest_rate: '' }]);
  };

  const removeBracket = (index) => {
    setBrackets(brackets.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (!loanType.trim()) {
      setError("Loan type name is required.");
      return;
    }
    if (brackets.some(b => !b.range.trim() || b.interest_rate === '')) {
      setError("All brackets must have range and interest rate.");
      return;
    }

    try {
      const res = await fetch('/api/loanRates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ loan_type: loanType.trim(), brackets }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to create loan type");

      if (onCreated) onCreated(data.data);
      setOpen(false);
      if (onClose) onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Popup open={open} closeOnDocumentClick onClose={() => { setOpen(false); if(onClose) onClose(); }} modal>
      <div className="editModal" style={{ overflow:"scroll"}}>
        <button className="close" onClick={() => { setOpen(false); if(onClose) onClose(); }}>
          &times;
        </button>
        <p className="modal-title">Create New Loan Type</p>
        <form onSubmit={handleSubmit} className="modal-content">
          <div className="text-input-container">
            <label>Loan Type Name</label>
            <input
              type="text"
              value={loanType}
              onChange={e => setLoanType(e.target.value)}
              required
            />
          </div>

          {brackets.map((b, i) => (
            <div key={i} className="modal-row">
              <div className="text-input-container">
                <label>Range</label>
                <input
                  type="text"
                  value={b.range}
                  onChange={e => handleBracketChange(i, 'range', e.target.value)}
                  required
                />
              </div>
              <div className="text-input-container">
                <label>Interest Rate (%)</label>
                <input
                  type="number"
                  value={b.interest_rate}
                  onChange={e => handleBracketChange(i, 'interest_rate', parseFloat(e.target.value))}
                  required
                />
              </div>
              {brackets.length > 1 && (
                <FaTrash
                  onClick={() => removeBracket(i)}
                  style={{ cursor: 'pointer', color: 'red', marginLeft: '10px', alignSelf: 'center' }}
                />
              )}
            </div>
          ))}

          <div className="add-btn-container">
            <FaPlus onClick={addBracket} className="add-btn" />
          </div>

          {error && <p style={{ color: 'red' }}>{error}</p>}

          <button type="submit" className="submit-btn">
            Create Loan Type
          </button>
        </form>
      </div>
    </Popup>
  );
}

export default ModalCreateLoanType;
